import { Account, AccountAccessMethod, AccountAccessRole, EnvironmentAccessRole } from '@stigg-types/apiTypes';
import { LoginOptionsForm, RolesFormFields } from './LoginOptions.types';
import { User } from '@auth0/auth0-react';

export const DEFAULT_SSO_ROLES = {
  accountRole: AccountAccessRole.Member,
  nonProductionAccess: EnvironmentAccessRole.Viewer,
  productionAccess: EnvironmentAccessRole.Viewer,
};

export const AUTHORIZED_DOMAIN_RBAC_DISABLED_DEFAULT_ROLES = {
  accountRole: AccountAccessRole.Owner,
  nonProductionAccess: EnvironmentAccessRole.Admin,
  productionAccess: EnvironmentAccessRole.Admin,
};

export const AUTHORIZED_DOMAIN_RBAC_ENABLED_DEFAULT_ROLES = {
  accountRole: AccountAccessRole.Member,
  nonProductionAccess: EnvironmentAccessRole.Viewer,
  productionAccess: EnvironmentAccessRole.Viewer,
};

export function getAuthorizedDomainRolesValues(
  rbacAccess: boolean,
  accountExistingRoles?: Account['defaultSSORoles'],
): RolesFormFields {
  if (!rbacAccess) return AUTHORIZED_DOMAIN_RBAC_DISABLED_DEFAULT_ROLES;

  return {
    accountRole: accountExistingRoles?.accountRole || AUTHORIZED_DOMAIN_RBAC_ENABLED_DEFAULT_ROLES.accountRole,
    nonProductionAccess:
      accountExistingRoles?.nonProductionRole || AUTHORIZED_DOMAIN_RBAC_ENABLED_DEFAULT_ROLES.nonProductionAccess,
    productionAccess:
      accountExistingRoles?.productionRole || AUTHORIZED_DOMAIN_RBAC_ENABLED_DEFAULT_ROLES.productionAccess,
  };
}

export function getDefaultFormValues(
  rbacAccess: boolean,
  account?: Account | null,
  userDomain?: string,
): LoginOptionsForm {
  if (!account) return { accessMethod: AccountAccessMethod.InviteOnly };

  const authorizedDomainRoles = getAuthorizedDomainRolesValues(rbacAccess, account.defaultSSORoles);

  return {
    accessMethod: account.accessMethod || AccountAccessMethod.InviteOnly,
    authorizedDomain: account.accountEmailDomain || userDomain || '',
    authorizedDomainRoles: authorizedDomainRoles,
    ssoRoles: {
      accountRole: account.defaultSSORoles?.accountRole || DEFAULT_SSO_ROLES.accountRole,
      nonProductionAccess: account.defaultSSORoles?.nonProductionRole || DEFAULT_SSO_ROLES.nonProductionAccess,
      productionAccess: account.defaultSSORoles?.productionRole || DEFAULT_SSO_ROLES.productionAccess,
    },
  };
}

export function getUserDomain(user: User | undefined) {
  const [, domain] = user?.email?.split('@') || [];
  if (!domain) return '';
  return domain;
}
